// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___u0Uj","col":"styles_col__1A9LB","actions":"styles_actions__3qb1b","conflict":"styles_conflict__f9rsn"};